const BACK_URL = 'https://ftn-scripts-staging.herokuapp.com/api';

export default BACK_URL;
